import { useEffect, useState } from 'react'

import './Authorize.css'

const Octopus = () => (
  <svg
    width="80"
    height="94"
    viewBox="0 0 80 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.56 48.108H72.8951C76.8126 48.108 80.0005 51.1906 80 54.9813C80 58.7695 76.8116 61.8536 72.8941 61.8536H62.0112C61.2008 61.8536 60.4727 62.3262 60.1633 63.0504C59.8554 63.7746 60.0278 64.6065 60.6027 65.1592L68.5284 72.7648C69.8728 74.0664 70.6147 75.7945 70.6147 77.6298C70.6147 79.4665 69.8762 81.1908 68.5333 82.4901C67.1913 83.7884 65.406 84.5021 63.5083 84.5021C61.6112 84.5021 59.8259 83.7884 58.478 82.4849L50.5135 74.8402C49.941 74.2904 49.0813 74.1255 48.3375 74.4271C47.5906 74.7278 47.1068 75.432 47.1068 76.2128V86.7934C47.1068 90.5826 43.9175 93.6667 39.9985 93.6667C36.081 93.6667 32.8917 90.5826 32.8917 86.7934V76.2033C32.8917 75.4234 32.4074 74.7201 31.6635 74.4195C31.4138 74.319 31.1522 74.2713 30.8935 74.2713C30.3782 74.2713 29.8693 74.4638 29.4875 74.8307L21.4806 82.4977C20.1436 83.7903 18.3622 84.5021 16.4636 84.5021C14.5664 84.5021 12.7801 83.7884 11.4396 82.4901C10.0972 81.1913 9.35624 79.4661 9.35624 77.6298C9.35624 75.7945 10.0972 74.0683 11.4317 72.7767L19.3849 65.1621C19.9618 64.6094 20.1367 63.7756 19.8273 63.0514C19.5189 62.3262 18.7888 61.8536 17.9784 61.8536H7.10684C3.1869 61.8536 0 58.7695 0 54.9813C0 51.1901 3.1869 48.1075 7.10684 48.1075H17.3439C18.0016 48.1075 18.6159 47.7954 18.9879 47.2756C19.3633 46.7534 19.4475 46.0878 19.2165 45.4937L15.328 35.4859L15.2945 35.3968L15.0044 34.6521C14.999 34.6306 14.9921 34.6101 14.9832 34.5882C14.5787 33.4838 14.2511 32.357 14.0117 31.2407C13.6452 29.5293 13.458 27.7669 13.458 26.0012C13.458 11.8477 25.3661 0.333333 40.0005 0.333333C54.6359 0.333333 66.542 11.8477 66.542 26.0012C66.542 29.0199 66.0051 31.9778 64.9405 34.8022L64.9035 34.8941L60.6934 45.4799C60.4564 46.075 60.5397 46.7434 60.9116 47.268C61.285 47.794 61.8999 48.108 62.56 48.108ZM52.7762 25.1145L43.2003 16.1774C42.2325 15.2742 40.6634 15.2742 39.6955 16.1774C38.7277 17.0807 38.7277 18.5452 39.6955 19.4484L45.0408 24.4371H27.4804C26.1116 24.4371 25.0021 25.4726 25.0021 26.75C25.0021 28.0274 26.1116 29.0629 27.4804 29.0629H45.0408L39.6955 34.0516C38.7277 34.9548 38.7277 36.4193 39.6955 37.3226C40.6634 38.2258 42.2325 38.2258 43.2003 37.3226L52.7762 28.3855C53.7441 27.4822 53.7441 26.0178 52.7762 25.1145Z"
      fill="#ACBDD3"
    />
  </svg>
)

const Authorize = () => {
  const [status, setStatus] = useState('loading')

  useEffect(() => {
    const element: any = document.getElementsByClassName('App-roadmap')

    if (element.length) {
      element[0].style = 'display: none'
    }

    return () => {
      if (element.length) {
        element[0].style = ''
      }
    }
  })

  useEffect(() => {
    if (window.opener) {
      const [_, code] =
        window.location.search.match(/.*code=([^&|\n|\t\s]+)/) || []

      window.opener.postMessage(
        {
          type: 'code',
          data: code,
        },
        window.origin
      )

      window.onmessage = ({ data: { isSuccess } }: any) => {
        if (isSuccess !== undefined) {
          if (isSuccess === true) {
            setStatus('success')
          } else {
            setStatus('error')
          }
        }
      }
    }
  }, [])

  return (
    <div className="Authorize">
      <div className="Authorize_container">
        <div className="Authorize_logo">
          <Octopus />
        </div>

        <div className="Authorize_description">
          {status === 'loading'
            ? `Authorizing... Please don't close this window.`
            : status === 'success'
              ? 'Authorized! You can close this window.'
              : 'Authorization failed, you can close this window.'}
        </div>
      </div>
    </div>
  )
}

export default Authorize
